import React from "react";
import './LoginForm.scss';

const LoginForm = ({
  email,password,handleEmailChange,handlePasswordChange, handleSubmit
}) => {
  return (
    <div className="login-form__container">
      <form className="login-form" onSubmit={handleSubmit}>
        <input type="text" placeholder="Email" className="login-form__username" value={email} onChange={handleEmailChange}></input>
        <input type="password" placeholder="Password" className="login-form__password"  value={password} onChange={handlePasswordChange}></input>
        <button type="submit" className="login-form__button">Login</button>
      </form>
    </div>
  );
};

export default LoginForm;
